import { CardData } from 'src/models/CardActivities/CardData';
import { SpotlightLayoutType, MediaType } from 'src/utils/enums';
import SpotlightCardContent, { SpotlightContent } from '../spotlight-card-content/SpotlightCardContent';

interface RightSideImageSpotlightProps {
  card: CardData
}

const RightSideImageSpotlight: React.FC<RightSideImageSpotlightProps> = ({ card }: RightSideImageSpotlightProps) => {
  const templateData = card.templateData;
  if (!templateData) return null;

  const content: SpotlightContent = {
    headline: templateData.headline,
    body: templateData.body,
    callToAction: templateData.callToAction,
    actionURL: templateData.actionURL,
    mediaUrl: templateData.image,
    mediaType: MediaType.IMAGE,
  };

  return (
    <div data-testid="right-side-image-spotlight">
      <SpotlightCardContent content={content} layoutType={SpotlightLayoutType.TEXT_LEFT_MEDIA_RIGHT} />
    </div>
  );
};

export default RightSideImageSpotlight;
